export const getFacilityRevolvingTypes = state => {
  const item = state.facilities.facilityRevolvingTypes;
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content = item && item.loaded ? Object.values(state.facilities.entities.facilityRevolvingTypes) : [];

  return { loading, loaded, content };
};

export const getFacilityFlexibilityRules = state => {
  const item = state.facilities.facilityFlexibilityRules;
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content = item && item.loaded ? Object.values(state.facilities.entities.facilityFlexibilityRules) : [];

  return { loading, loaded, content };
};

export const getFacilityCreditLineStatuses = state => {
  const item = state.facilities.facilityCreditLineStatuses;
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content = item && item.loaded ? Object.values(state.facilities.entities.facilityCreditLineStatuses) : [];

  return { loading, loaded, content };
};

export const getFacilityPurposesForApplication = state => {
  const item = state.facilities.facilityPurposesForApplication;
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content = item && item.loaded ? Object.values(state.facilities.entities.facilityPurposesForApplication) : [];

  return { loading, loaded, content };
};

export const getPartnerGroups = state => {
  const item = state.facilities.facilityPartnerGroups;
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content =
    item && item.loaded && state.facilities.entities.facilityPartnerGroups
      ? Object.values(state.facilities.entities.facilityPartnerGroups)
      : [];

  return { loading, loaded, content };
};

export const getTransferToERPPermissions = (state, documentId) => {
  const item = state.facilities.transferFacilityToERPPermissions[documentId]
    ? state.facilities.transferFacilityToERPPermissions[documentId]
    : [];
  const loaded = item && item.loaded ? true : false;
  const loading = item && item.loading ? true : false;
  const content =
    item && item.loaded ? state.facilities.transferFacilityToERPPermissions[documentId].transferToERPPermissions : {};
  return { loading, loaded, content };
};

export const getFacilityWarranties = (documentId, state) => {
  const facilityWarranties = state.facilities.facilityWarranties[documentId]
    ? state.facilities.facilityWarranties[documentId]
    : [];
  const facilityWarrantiesEntities = state.facilities.entities.facilityWarranties
    ? state.facilities.entities.facilityWarranties
    : [];

  const loaded = facilityWarranties && facilityWarranties.loaded ? facilityWarranties.loaded : false;
  const loading = facilityWarranties && facilityWarranties.loading ? facilityWarranties.loading : false;
  const content = loaded ? facilityWarranties.ids.map(id => facilityWarrantiesEntities[id]) : [];
  return { content, loading, loaded };
};
